var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"component",staticClass:"dropdown nav-item",class:{ show: _vm.isOpen },on:{"click":_vm.toggleDropDown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }